/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetAppraisalsByIdAndProjectIdParams,
  PutAppraisalsByIdAndProjectIdParams,
  DeleteAppraisalsByIdAndProjectIdParams,
  PostGuestAppraisalsAiByProjectIdParams,
  PostAppraisalsByProjectIdParams,
  PostAppraisalsAiByProjectIdParams,
  GetGuestAppraisalsByIdParams,
  GetAppraisalsSummaryByProjectIdParams,
  GetAppraisalsProjectByProjectIdParams,
  GetAppraisalsProjectByProjectIdAndNodeIdParams,
  GetAppraisalsSummaryByProjectIdQuery,
  GetAppraisalsProjectByProjectIdQuery,
  GetAppraisalsProjectByProjectIdAndNodeIdQuery,
  PutAppraisalsByIdAndProjectIdBody,
  PostGuestAppraisalsAiByProjectIdBody,
  PostAppraisalsByProjectIdBody,
  PostAppraisalsAiByProjectIdBody,
  GetAppraisalsByIdAndProjectIdResponse,
  PutAppraisalsByIdAndProjectIdResponse,
  PostGuestAppraisalsAiByProjectIdResponse,
  PostAppraisalsByProjectIdResponse,
  PostAppraisalsAiByProjectIdResponse,
  GetGuestAppraisalsByIdResponse,
  GetAppraisalsSummaryByProjectIdResponse,
  GetAppraisalsProjectByProjectIdResponse,
  GetAppraisalsProjectByProjectIdAndNodeIdResponse,
} from '../types';

export class Appraisals extends Controller {
  async getAppraisalsByIdAndProjectId<
    T extends GetAppraisalsByIdAndProjectIdResponse,
    D,
    C
  >(
    { id, projectId }: GetAppraisalsByIdAndProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/appraisals/${projectId}/${id}`,
      axiosConfig
    );
  }

  async putAppraisalsByIdAndProjectId<
    T extends PutAppraisalsByIdAndProjectIdResponse,
    D,
    C extends PutAppraisalsByIdAndProjectIdBody
  >(
    body: C,
    { id, projectId }: PutAppraisalsByIdAndProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/appraisals/${projectId}/${id}`,
      body,
      axiosConfig
    );
  }

  async deleteAppraisalsByIdAndProjectId<T, D, C extends null>(
    { id, projectId }: DeleteAppraisalsByIdAndProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/appraisals/${projectId}/${id}`,
      { ...axiosConfig, data: body }
    );
  }

  async postGuestAppraisalsAiByProjectId<
    T extends PostGuestAppraisalsAiByProjectIdResponse,
    D,
    C extends PostGuestAppraisalsAiByProjectIdBody
  >(
    body: C,
    { projectId }: PostGuestAppraisalsAiByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/guest/appraisals/${projectId}/ai`,
      body,
      axiosConfig
    );
  }

  async postAppraisalsByProjectId<
    T extends PostAppraisalsByProjectIdResponse,
    D,
    C extends PostAppraisalsByProjectIdBody
  >(
    body: C,
    { projectId }: PostAppraisalsByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/appraisals/${projectId}`,
      body,
      axiosConfig
    );
  }

  async postAppraisalsAiByProjectId<
    T extends PostAppraisalsAiByProjectIdResponse,
    D,
    C extends PostAppraisalsAiByProjectIdBody
  >(
    body: C,
    { projectId }: PostAppraisalsAiByProjectIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/appraisals/${projectId}/ai`,
      body,
      axiosConfig
    );
  }

  async getGuestAppraisalsById<T extends GetGuestAppraisalsByIdResponse, D, C>(
    { id }: GetGuestAppraisalsByIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/guest/appraisals/${id}`,
      axiosConfig
    );
  }

  async getAppraisalsSummaryByProjectId<
    T extends GetAppraisalsSummaryByProjectIdResponse,
    D,
    C
  >(
    { projectId }: GetAppraisalsSummaryByProjectIdParams,
    query: GetAppraisalsSummaryByProjectIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/appraisals/${projectId}/summary`, query),
      axiosConfig
    );
  }

  async getAppraisalsProjectByProjectId<
    T extends GetAppraisalsProjectByProjectIdResponse,
    D,
    C
  >(
    { projectId }: GetAppraisalsProjectByProjectIdParams,
    query: GetAppraisalsProjectByProjectIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/appraisals/project/${projectId}`, query),
      axiosConfig
    );
  }

  async getAppraisalsProjectByProjectIdAndNodeId<
    T extends GetAppraisalsProjectByProjectIdAndNodeIdResponse,
    D,
    C
  >(
    { projectId, nodeId }: GetAppraisalsProjectByProjectIdAndNodeIdParams,
    query: GetAppraisalsProjectByProjectIdAndNodeIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(`/appraisals/project/${projectId}/${nodeId}`, query),
      axiosConfig
    );
  }
}
